export default __webpack_public_path__ + "static/media/leave_house.19fb1d07.png";